import React from 'react';
import './App.scss';
import { NavLink, useRouteMatch } from "react-router-dom";
import UrlHelper from "./helper/UrlHelper";
import * as Constants from "./helper/Constants";

function PrimaryNav(props) {
    const {path, url} = useRouteMatch();
    return (
        <ul className="primary-navbar">
            <li>
                <NavLink to={UrlHelper.join(url, Constants.LINK_ALL_CATEGORIES_RELATIVE)} activeClassName="selected-navitem">
                    PROJEKTE
                </NavLink>
            </li>
            <li>
                <NavLink to={UrlHelper.join(url, Constants.LINK_CONTACT_RELATIVE)} activeClassName="selected-navitem">
                    KONTAKT / IMPRESSUM
                </NavLink>
            </li>
        </ul>
    );
}

export default PrimaryNav;
